//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'CHA2DS2VASc',
  data() {
    return {
      defaultJson: {
        "Hypertension": "高血压",
        "Adj. Stroke Rate": "脑卒中发生率",
        "Chronic Heart Failure": "慢性心衰",
        "Prior Stroke or TIA": "既往脑卒中或 TIA",
        "≤ 64": "≤ 64",
        "65-74": "65 - 74",
        "≥ 75": "≥ 75",
        "Diabetes Mellitus": "糖尿病",
        "Vascular Disease": "血管病",
        "Defined as prior myocardial infarction, peripheral artery disease, or aortic plaque": "定义为既往心肌梗死、周围动脉病变、或主动脉斑块。",
        "Age": "年龄"
      },
      form: {
        hf: '0',
        hta: '0',
        vasc: '0',
        diab: '0',
        prior: '0',
        gender: '',
        age: ''

      },
      dataList1: [
        { value: "0", name: '男' },
        { value: "1", name: '女' },
      ],
      dataList2: [
        { value: "0", name: '≤ 64' },
        { value: "1", name: '65-74' },
        { value: "2", name: '≥ 75' },
      ],
      scoreObj: {
        0: 0,
        1: 1.3,
        2: 2.2,
        3: 3.2,
        4: 4,
        5: 6.7,
        6: 9.8,
        7: 9.6,
        8: 6.7,
        9: 15.2
      },
      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // hf + hta + vasc + gender + age
        // hf + hta + vasc + age + diab + (prior ? 2 : 0) + gender.isFemale
        let result = form.hf + form.hta + form.vasc + form.age + form.diab + form.prior * 2 + form.gender

        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/CHA2DS2VASc.vue